import { connect } from "react-redux";
import CreateInvitationModal, {
  CreateInvitationModalProps as _CreateInvitationModalProps,
} from "./create-invitation-modal-container";
import { AppState } from "../../../store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import OrganizationUtils from "../../../utils/organization";
import {
  clearError,
  createAndSendOrganizationGroupInvitation,
  listOrganizationGroups,
  listOrganizationRoles,
} from "../../../actions";
import { CreateInvitationModalDataProps } from "./create-invitation-modal-view";
import InProgressUtils from "../../../utils/in-progress";
import { ActionSender } from "../../../model/ActionSender";
import AuthenticationUtils from "../../../utils/authentication";
import { addSenderArgument } from "../../../actions/actionHelpers";

export type CreateInvitationModalProps = Omit<
  _CreateInvitationModalProps,
  keyof CreateInvitationModalDataProps
>;

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _CreateInvitationModalProps,
  CreateInvitationModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _CreateInvitationModalProps,
  CreateInvitationModalProps
>;

const sender: ActionSender = { key: "create-invitation" };
function mapStateToProps(
  state: AppState,
  ownProps: CreateInvitationModalProps
): ReduxStateProps {
  const organization = OrganizationUtils.selectSelectedOrganization(state);
  return {
    orgAdminRoleId: OrganizationUtils.selectOrgAdminRoleId(state),
    organizationId: organization?.id as string,
    organizationName: organization?.name as string,
    userName: AuthenticationUtils.selectAuthenticationUserDisplayName(state),
    groups: OrganizationUtils.selectOrganizationGroups(state),
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
  };
}
function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    AuthenticationUtils.compareAuthenticationUserDisplayNameStates(
      next,
      prev
    ) &&
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareSelectedOrganizationStates(next, prev) &&
    OrganizationUtils.compareOrganizationGroupsStates(next, prev) &&
    OrganizationUtils.compareOrganizationRolesStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onLoadOrgadminRole: addSenderArgument(sender, listOrganizationRoles),
  onCreateInvitation: addSenderArgument(
    sender,
    createAndSendOrganizationGroupInvitation
  ),
  onLoadGroups: addSenderArgument(sender, listOrganizationGroups),
  onClearError: clearError,
};

export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  CreateInvitationModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(CreateInvitationModal);
